import { FormControlProps } from '../interfaces/FormControlProps';

export class PropertyHelpers {
    static getFieldID(props: FormControlProps) {
        return props.formFieldDefinition.name;
    }

    static getFieldReference(props: FormControlProps) {
        return props.formFieldDefinition.name;
    }

    static getMaxLength(props: FormControlProps, defaultLength: number) {
        return !!props.formFieldDefinition.maxlength
            ? props.formFieldDefinition.maxlength
            : defaultLength;
    }

    static getName(props: FormControlProps) {
        return props.formFieldDefinition.name;
    }

    static getValue(props: FormControlProps) {
        return props.field.value;
    }
    
    static hasRelatedDataUrl(props: FormControlProps): boolean {
        return (
            (props.formFieldDefinition.datasource &&
            props.formConfig.urlMappingsRelatedData &&
            props.formConfig.urlMappingsRelatedData[props.formFieldDefinition.datasource]) ||

            (props.formFieldDefinition.triggerDatasource &&
                props.formConfig.urlMappingsRelatedData &&
                props.formConfig.urlMappingsRelatedData[props.formFieldDefinition.triggerDatasource])

        );
    }

    static getRelatedDataUrl(props: FormControlProps, parameters: string) {
        if (props.formFieldDefinition.triggerDatasource) {
            return (
                props.formConfig.urlMappingsRelatedData[props.formFieldDefinition.triggerDatasource] + parameters
            );
        }
        
        if (props.formFieldDefinition.datasource) {
            return (
                props.formConfig.urlMappingsRelatedData[props.formFieldDefinition.datasource] + parameters
            );
        }
        return "";
    }

    static isActionUrl(props: FormControlProps) {
        return (props.formConfig.urlMappingsRelatedData[props.formFieldDefinition.datasource] !== undefined &&
            props.formConfig.urlMappingsRelatedData[props.formFieldDefinition.datasource].toLowerCase().indexOf("action:") === 0)  ||
            (props.formConfig.urlMappingsRelatedData[props.formFieldDefinition.triggerDatasource] !== undefined &&
                props.formConfig.urlMappingsRelatedData[props.formFieldDefinition.triggerDatasource].toLowerCase().indexOf("action:") === 0)
            ;    
    }

    static maskCharsExpression(props: FormControlProps) {
        return typeof props.formFieldDefinition.maskCharsExpression !== undefined;
    }

    static getMaskCharsExpression(props: FormControlProps) {
        return props.formFieldDefinition.maskCharsExpression;
    }
}
